import { Injectable } from "@angular/core";
//import{Http, Headers, RequestOptions} from '@angular/http';
import {
  HttpClientModule,
  HttpClient,
  HttpResponse,HttpHeaders
} from "@angular/common/http";
import { Observable } from "rxjs";

import { catchError, map, retry } from "rxjs/operators";
import { Router, ActivatedRoute } from "@angular/router";
import { default as swal } from "sweetalert2";
import { environment } from "../../environments/environment";
/* import { tokenNotExpired } from 'angular2-jwt'; */
import { JwtHelperService } from "@auth0/angular-jwt";

declare var $: any;

const helper = new JwtHelperService();
const jwtHelper: JwtHelperService = new JwtHelperService();

var authToken;
var options;
/* let httpHeaders = new HttpHeaders({
  'Content-Type' : 'application/json',
  'Cache-Control': 'no-cache'
}); */

@Injectable()
export class AuthService {
  domain = "http://3.6.12.176:8777/api"; //environment.apiURL;
 //domain = "http://localhost:8777/api"; //environment.apiURL;

  products = null;
  authToken;
  user;
  options;
  public permissions: any = {
    dashboard: false,
    stockImport: false,
    createCategory: false,
    unallotedStockList: false,
    stockList: false,
    deviceMovement: false,
    courierMovement: false,
    courierList: false,
    deleteDevice: false,
  };

  constructor(private http: HttpClient, private router: Router) {}


  loggedIn() {
    //return tokenNotExpired();
    let myRawToken = localStorage.getItem('token');
    const decodedToken = helper.decodeToken(myRawToken);
    //const expirationDate = helper.getTokenExpirationDate(myRawToken);
    const isExpired = helper.isTokenExpired(myRawToken);

    return (!isExpired);
  }

  createAuthenticationHeaders(){

    /* return new RequestOptions({
      headers: new Headers( 
        { 
          'Content-Type':'application/json', 
           'authorization': localStorage.getItem('token')  
        })
    }) */

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': localStorage.getItem('token')
   });
   let options = {
      headers: headers
   }

   return options
  }

  login(user) {
    return this.http
      .post(this.domain + "/user/login", user)
      .pipe(map((res) => res));
  }

  storeUserData(token, user){
    localStorage.setItem('token',token),
    localStorage.setItem('user', JSON.stringify(user));
    this.authToken=token,
    this.user=user;
  }

  /*
  resetPassword(details){
    return this.http.post(this.domain+'authentication/resetPassword', details).pipe(map(res => res.json()));
  }
  
  
  uploadExcel(details){
    return this.http.post(this.domain+'authentication/uploadsealfile', details).pipe(map(res => res.json()));
  } */


  __logout__() {    
    this.authToken = null;
    this.user = null;
    localStorage.clear();
    closeDialog("logoutModal"); 
    this.router.navigate(["./login"])
  }
  addCategory(args) {
    return this.http
      .post(this.domain + "/common/set/category", args,this.createAuthenticationHeaders())
      .pipe(map((res: Response) => res));
  }

  

  addApprover(args) {
    return this.http
      .post(this.domain + "/common/set/approver", args,this.createAuthenticationHeaders())
      .pipe(map((res: Response) => res));
  }

  deleteApprover(args) {
    return this.http
      .post(this.domain + "/common/unset/approver", args,this.createAuthenticationHeaders())
      .pipe(map((res: Response) => res));
  }


  deleteTemplate(args) {
    return this.http
      .post(this.domain + "/common/unset/template", args,this.createAuthenticationHeaders())
      .pipe(map((res: Response) => res));
  }
  

  
  listCategory(args) {
    console.log("====args inside auth service");
    console.log(args);   
    
    return this.http
      .post(this.domain + "/common/list/category", args,this.createAuthenticationHeaders())
      .pipe(map((res: Response) => res));
  }

  listApprovers(args) {
    console.log("====args inside auth service");
    console.log(args);   
    
    return this.http
      .post(this.domain + "/common/list/approvers", args,this.createAuthenticationHeaders())
      .pipe(map((res: Response) => res));
  }
  getProjects(args) {
    return this.http
      .post(this.domain + "/setting/get/projects", args,this.createAuthenticationHeaders())
      .pipe(map((res: Response) => res));
  }



  addProject(args) {
    return this.http
      .post(this.domain + "/setting/set/project", args,this.createAuthenticationHeaders())
      .pipe(map((res: Response) => res));
  }

  listMailer(args) {
    return this.http
      .post(this.domain + "/common/list/master", args,this.createAuthenticationHeaders())
      .pipe(map((res: Response) => res));
  }

  addMailer(args) {
    return this.http
      .post(this.domain + "/common/set/master", args,this.createAuthenticationHeaders())
      .pipe(map((res: Response) => res));
  } 

  addTemplate(args) {
    return this.http
      .post(this.domain + "/common/set/template", args,this.createAuthenticationHeaders())
      .pipe(map((res: Response) => res));
  }

  triggerMail(args) {
    return this.http
      .post(this.domain + "/common/trigger/mail", args,this.createAuthenticationHeaders())
      .pipe(map((res: Response) => res));
  }

  listTemplate(args){
    return this.http.post(this.domain+"/common/list/template",args,this.createAuthenticationHeaders())
    .pipe((map((res:any) => res)))
  }
  

  getTemplate(args) {
    return this.http
      .post(this.domain + "/common/get/template", args,this.createAuthenticationHeaders())
      .pipe(map((res: Response) => res));
  }

  editTemplate(args) {
    return this.http
      .post(this.domain + "/common/edit/template", args,this.createAuthenticationHeaders())
      .pipe(map((res: Response) => res));
  }

  sendOTP(args){
    return this.http.post(this.domain+"/user/send_otp",args)
    .pipe((map((res:any) => res)))
  }

  resetPwd(args){
    return this.http.post(this.domain+"/user/reset_pwd",args)
    .pipe((map((res:any) => res)))
  }
  
  changePwd(args){
    return this.http.post(this.domain+"/user/change_pwd",args,this.createAuthenticationHeaders())
    .pipe((map((res:any) => res)))
  }
  
}


function closeDialog(selectr) {
  $("#" + selectr).modal("hide");
}


// WEBPACK FOOTER //
// /home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/src/app/services/auth.service.ts